import React, { useEffect } from 'react';

import { useHistory } from 'react-router';

export function useDynamicRedirect(basePath: string, subPath: string) {
    const history = useHistory();

    // redirect to the sub-path if we ended up on the base path
    useEffect(() => {
        if (history.location.pathname === basePath) {
            history.push(basePath + subPath);
        }
    }, [history.location.pathname, basePath]);
}
